import './style.css';
import React, { useEffect, useState } from 'react';
import MasterPage from 'components/MasterPage';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { Card, Col, Row, Table, Form, Button, Modal } from 'react-bootstrap';
import { DashboardOutlined, AddOutlined, Description } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import { api } from 'services';
import { parseDateBR  } from 'helpers/date';
import { DebounceInput } from 'react-debounce-input';
import { useHistory } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

const ListingAdvance = () => {
	const { t } = useTranslation();
	const user = useSelector(state => state.user ? state.user : null);
	const profile = user.profiles[0] ? user.profiles[0] : null;
	const defaultFilters = { __search: '', per_page: 10, page: 1 };

	const [filters, setFilters] = useState(defaultFilters);
	const [invoices, setInvoices] = useState([]);
	const [pagination, setPagination] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [childrenList, setChildrenList] = useState([]);

	const history = useHistory();

	useEffect(() => {
		let aux_filters = {
			__is_advance: 1,
			...filters
		}

		api.get('invoices', { params: { ...aux_filters } })
			.then(({ data: response }) => {
				const { data, pagination } = response
				setInvoices(buildData(data))
				setPagination(pagination)
			})
	}, [filters])

	const buildData = (data) => {
		const actionLink = (item) => {
			return (
				item.action_id ? (
					<a target="_blank" href={`/actions/edit/${item.action_id}`}>{`#${item.action_id}`}</a>
				) : "---"
			)
		}

		const fileLink = (item) => {
			return (
				item.advance_children[0] ? (<>
					<ReactTooltip place="right"/>
					<a href={item.advance_children[0].files[0].uri} target="_blank" data-html={true} data-tip={item.advance_children[0].files[0].name}><Description /></a>
				</>) : "---"
			)
		}

		const getCurrency = (item) => {
			let cCode = 'BRL';
	
			if (item.currency == 2) {
				cCode = 'USD';
			} else if (item.currency == 3) {
				cCode = 'EUR';
			}
	
			return item.value.toLocaleString('pt-BR', {
				style: 'currency',
				currency: cCode
			});
		}

		const getIssuanceDate = (item) => {
			if (item.advance_children.length) {
				let date = item.advance_children[0].issuance_date;
				return date ? parseDateBR(date) : '---';
			} else {
				return item.issuance_date ? parseDateBR(item.issuance_date) : "---";
			}
		}

		return data.map(item => {
			return {
				id: item.id,
				invoice_number: item.advance_children[0] ? item.advance_children[0].invoice_number : "---",
				service_provider: item.service_provider,
				action_link: actionLink(item),
				currency: getCurrency(item),
				due_date: item.due_date ? parseDateBR(item.due_date) : '---',
				issuance_date: getIssuanceDate(item),
				file_link: fileLink(item), 
				status: getStatus(item.status.id),
				button_actions: generateActionButtons(item)
			}
		})
	}

	const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

	

	const getStatus = (statusParam) => {
		let status = '';
		if (statusParam === 8) {
			status += t('statuses:approved_nf');
		} else if (statusParam === 6) {
			status += t('statuses:on_approval_nf');
		} else if (statusParam === 7) {
			status += t('statuses:disapproved_nf');
		}
		return status;
	};

	const generateActionButtons = (data) => {
		return (<>
			<ReactTooltip place="right"/>
			<Button 
				size="sm" 
				data-tip="Adicionar Nota"
				variant="success"
				disabled={data.advance_children.length > 0 || data.status.id != 8}
				onClick={() => history.push(`/files/add-invoice/advance-children/${data.id}`)}
			>
				<AddOutlined />
			</Button>

			{/* <Button 
				className="ml-2" 
				size="sm" 
				variant="info"
				disabled={data.advance_children.length <= 0}
				onClick={() => {
					setChildrenList(data.advance_children);
					setShowModal(true)
				}}
			>
				<ListOutlined />
			</Button> */}
		</>)
	}

	return (<>
		<Card.Body className="shadow bg-white rounded mb-3">
			<Row>
				<Col className="d-flex mt-3 mb-3">
					<DashboardOutlined className="icon-title" />
					<h4 className="title-dashboard mt-2">{t('title:advances')}</h4>
				</Col>
			</Row>
			<Row>
				<Col md={3}>
					<Form.Group>
						<Form.Label>{t('label:records per page')}:</Form.Label>
						<Form.Control
							as="select"
							value={filters.per_page}
							onChange={(e) =>
								handleFilterChange({ per_page: e.target.value, page:1 })
							}
						>
							<option value={10}>10</option>
							<option value={25}>25</option>
							<option value={50}>50</option>
							<option value={100}>100</option>
						</Form.Control>
					</Form.Group>
				</Col>
				<Col md={3} className="ml-auto">
					<Form.Group>
						<Form.Label>{t('label:search')}:</Form.Label>
						<DebounceInput
							element={Form.Control}
							debounceTimeout={500}
							value={filters.__search}
							onChange={(e) =>
								handleFilterChange({ __search: e.target.value, page:1 })
							}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col>
					<Table bordered>
						<thead className="text-center">
							<tr>
								<th>ID</th>
								<th>NF</th>
								<th>Razão Social</th>
								<th>Ação</th>
								<th>Valor</th>
								<th>Vencimento</th>
								<th>Data Emissão</th>
								<th>Nota</th>
								<th>Status</th>
								<th>Ações</th>
							</tr>
						</thead>
						<tbody className="text-center">
							{invoices.map((i, k) => (
								<tr key={k}>
									<td>{i.id}</td>
									<td>{i.invoice_number}</td>
									<td>{i.service_provider}</td>
									<td>{i.action_link}</td>
									<td>{i.currency}</td>
									<td>{i.due_date}</td>
									<td>{i.issuance_date}</td>
									<td>{i.file_link}</td>
									<td>{i.status}</td>
									<td>{i.button_actions}</td>
								</tr>
							))}
						</tbody>
					</Table>
				</Col>
			</Row>
			{pagination ? (
				<Row>
					<Col>
						<Trans i18nKey="label:interpolateShowingRecords">
							Showing {{ from: pagination.from || '0' }} to{' '}
							{{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
							records
						</Trans>
					</Col>
					<Col className="d-flex justify-content-end">
						<Pagination
							activePage={parseInt(pagination.current_page)}
							itemsCountPerPage={parseInt(pagination.per_page)}
							totalItemsCount={parseInt(pagination.total)}
							pageRangeDisplayed={5}
							onChange={(page) => {
								handleFilterChange({ page })
							}}
							itemClass="page-item"
							linkClass="page-link"
							prevPageText="‹"
							nextPageText="›"
						/>
					</Col>
				</Row>
			):''}
		</Card.Body>
		{/* <Modal 
			show={showModal}  
			onHide={() => {
				setChildrenList([]);
				setShowModal(false)
			}} 
			dialogClassName="modal-90w"
		>
			<Modal.Header closeButton>
				<Modal.Title>Notas Filhas</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Table bordered>
					<thead>
						<tr>
							<th>#</th>
							<th>Razão Social</th>
							<th>CNPJ</th>
							<th>Valor</th>
							<th>Arquivo</th>
						</tr>
					</thead>
					<tbody>
						{childrenList.map(c => (
							<tr>
								<td>{c.id}</td>
								<td>{c.service_provider}</td>
								<td>{c.document}</td>
								<td>{c.value}</td>
								<td><a href={c.files[0].uri}>Nota</a></td>
							</tr>
						))}
					</tbody>
				</Table>
			</Modal.Body>
		</Modal> */}
	</>)
}

export default MasterPage(ListingAdvance)